module.exports = __webpack_public_path__ + "static/WEDDING E&M-538-eea96d1916f4cf8327fa1a15e1dc4748.jpg";